import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';

/**
 * WhatsApp link component
 * Creates a clickable link to open WhatsApp chat with the given phone number
 */
export const WhatsAppLink = ({ phone, message = '', className = '' }) => {
  if (!phone) return null;
  
  // Clean phone number - remove spaces, dashes, etc
  const cleanPhone = phone.replace(/[\s\-\(\)\.]/g, '');
  
  // Add Italy country code if not present
  let formattedPhone = cleanPhone;
  if (!cleanPhone.startsWith('+')) {
    if (cleanPhone.startsWith('0')) {
      // Remove leading 0 and add +39
      formattedPhone = '+39' + cleanPhone.substring(1);
    } else if (!cleanPhone.startsWith('39')) {
      formattedPhone = '+39' + cleanPhone;
    } else {
      formattedPhone = '+' + cleanPhone;
    }
  }
  
  // Create WhatsApp URL
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${formattedPhone.replace('+', '')}${message ? `?text=${encodedMessage}` : ''}`;
  
  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-green-600 hover:text-green-700 transition-colors ${className}`}
      title="Apri WhatsApp"
    >
      <MessageCircle className="w-4 h-4" />
    </a>
  );
};

/**
 * Phone number display with WhatsApp link
 */
export const PhoneWithWhatsApp = ({ phone, message = '', showNumber = true }) => {
  if (!phone) return <span className="text-muted-foreground">-</span>;
  
  return (
    <span className="inline-flex items-center gap-2">
      {showNumber && <span>{phone}</span>}
      <WhatsAppLink phone={phone} message={message} />
    </span>
  );
};

export default WhatsAppLink;
